import { gql } from '@apollo/client';

export const ALL_INTERVENTIONS = gql`
  query AllInterventions($input: ExportArgs) {
    allInterventions(input: $input) {
      id
      name
    }
  }
`;
